import { render, staticRenderFns } from "./NoticeDetailPage.vue?vue&type=template&id=4a113407&lang=true&"
import script from "./NoticeDetailPage.vue?vue&type=script&lang=js&"
export * from "./NoticeDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./NoticeDetailPage.vue?vue&type=style&index=0&id=4a113407&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports